export const GET_ACTIVE_THEME_STARTED = 'GET_ACTIVE_THEME_STARTED'
export const GET_ACTIVE_THEME_SUCCESS = 'GET_ACTIVE_THEME_SUCCESS'
export const GET_ACTIVE_THEME_ERROR = 'GET_ACTIVE_THEME_ERROR'
export const SET_ACTIVE_THEME = 'SET_ACTIVE_THEME'
export const GET_ALL_THEMES = 'GET_ALL_THEMES'
